/**
 * File mypay-demo.js.
 * Handles logic for the MyPay Demo module
 */

const myPayDemo = document.querySelector('.mypay-demo__demo');
const myPayDemoTrigger = document.querySelector('.mypay-demo__trigger');
const myPayDemoClose = document.querySelector('.mypay-demo__demo-close');
const myPayDemoBack = document.querySelector('.mypay-demo__demo-back');
const myPayDemoTooltip = document.querySelector('.mypay-demo__demo-tooltip');
const myPayDemoTooltipClose = document.querySelector('.mypay-demo__demo-tooltip-close');
const myPayDemoNextBtns = document.querySelectorAll('.mypay-demo__demo-next');
const myPayDemoInput = document.querySelector('.mypay-demo__demo-input');
const myPayDemoInputSubmit = document.querySelectorAll('.mypay-demo__demo-input-submit');
const myPayDemoInputForm = document.querySelector('.mypay-demo__demo-input-form');
const myPayDemoSelect = document.querySelectorAll('.mypay-demo__demo-select');
const myPayDemoReplay = document.querySelector('.mypay-demo__demo-replay');
const myPayDemoDisclaimer = document.querySelector('.mypay-demo__demo-modal');
const myPayDemoPointer = document.querySelector('.mypay-demo__demo-pointer');
const myPayDemoOpenClass = 'mypay-demo__demo--open';
const myPayDemoTooltipActiveClass = 'mypay-demo__demo-tooltip--active';
const myPayDemoPageActiveClass = 'mypay-demo__demo-page--active';
const myPayDemoSelectedClass = 'mypay-demo__demo-select--selected';
const myPayDemoNextClass = 'mypay-demo__demo-page--next';
const viewport = window.visualViewport;
let inputVal = 0;
let scrollPos = null;

const setActivePage = (p = null, ot = true) => {

  // Remove the timeout function if the active page was changed
  if (typeof timer != "undefined") {
    clearTimeout(timer);
  }

  // get current active page index
  const page = myPayDemo.querySelector('.mypay-demo__demo-page--active');
  const index = page?.dataset.index || 0;

  // Automatically direct the user to the last page after 9s, if there's no interaction
  if (index == 3) {
    timer = setTimeout(() => {
      setActivePage(5);
    }, "9000");
  }

  // remove active class from current page
  page?.classList.remove(myPayDemoPageActiveClass);

  // show page
  const pageNum = p || parseInt(index) + 1;
  const pageToShow = myPayDemo.querySelector('.mypay-demo__demo-page[data-index="' + pageNum + '"]');

  // Hide the back button on the first slide
  if (pageNum == 1) {
    myPayDemoBack.style.display = 'none';
  } else {
    myPayDemoBack.style.display = 'block';
  }

  // Remove existing back button event listener and reinitialize with the correct
  myPayDemoBack.removeEventListener('click', function () {
    setActivePage(pageNum - 1);
  }, { once: true });
  myPayDemoBack.addEventListener('click', function () {
    setActivePage(pageNum - 1);
  }, { once: true });
  pageToShow.classList.remove(myPayDemoNextClass);
  pageToShow.classList.add(myPayDemoPageActiveClass);

  // open tooltip
  if (ot) openTooltip();

  // get next page index
  const nextIndex = parseInt(pageNum) + 1;
  const nextPage = myPayDemo.querySelector('.mypay-demo__demo-page[data-index="' + nextIndex + '"]');
  nextPage?.classList.add(myPayDemoNextClass);
};

const openDemo = () => {
  scrollPos = window.scrollY; // save scroll position
  setActivePage(1);
  myPayDemo.classList.toggle(myPayDemoOpenClass);
  openTooltip();
  myPayDemoClose.addEventListener('click', closeDemo, { once: true });
  document.body.classList.add('noscroll');

  // add class after open transition
  setTimeout(() => { 
    document.body.classList.add('mypay-demo-open');
  }, 750);
};

const closeDemo = () => {
  if (scrollPos) window.scrollTo(0, scrollPos); // reset scroll position
  myPayDemo.classList.remove(myPayDemoOpenClass);
  myPayDemoTooltip.classList.remove(myPayDemoTooltipActiveClass);
  setActivePage(1, false);
  resetPages();
  document.body.classList.remove('noscroll', 'mypay-demo-open');
}

const getActivePage = () => {
  return myPayDemo.querySelector('.mypay-demo__demo-page--active');
}

const getActivePageIndex = () => {
  return getActivePage()?.dataset.index;
}

const openTooltip = () => {
  const activePage = getActivePage();
  const activeTooltip = activePage.querySelector('.mypay-demo__demo-tooltip');
  const tooltipClose = activeTooltip?.querySelector('.mypay-demo__demo-tooltip-close');
  if (isMobile()) myPayDemo.addEventListener('click', closeTooltip);
  setTimeout(() => { 
    activeTooltip?.classList.add(myPayDemoTooltipActiveClass);
  }, 0);
}

const closeTooltip = () => {
  const activeTooltip = myPayDemo.querySelectorAll('.mypay-demo__demo-tooltip--active');

  // remove active class from all tooltips
  activeTooltip.forEach(el => {
    el.classList.remove(myPayDemoTooltipActiveClass);
  });
}

const viewportHandler = () => {
  if (getActivePageIndex() !== '2') return;

  const mobileSubmit = myPayDemo.querySelector('.mypay-demo__demo-input-submit.hide-desktop');
  const inputHeight = mobileSubmit.getBoundingClientRect().height || 45;
  let offsetTop =
    viewport.height -
    inputHeight +
    viewport.offsetTop -
    20; // buffer from bottom of screen

  // minimum top position to not overlap copy
  if (offsetTop < 545) {
    offsetTop = 545;
  }

  if (mobileSubmit) {
    mobileSubmit.style.bottom = 'auto';
    mobileSubmit.style.top = offsetTop + 'px';
  }
}

const storeInputVal = () => {
  inputVal = myPayDemoInput.value;
  myPayDemo.querySelectorAll('.mypay-demo__demo-amount').forEach(el => {
    el.textContent = inputVal;
  });
}

const enableNextBtn = (e) => {
  const parent = e.target.parentElement;
  const nextBtn = parent.querySelector('.mypay-demo__demo-next');
  removeSelectedSelect();
  e.target.classList.add(myPayDemoSelectedClass);

  // enable next button, add class to use in replay
  nextBtn.removeAttribute('disabled');
  nextBtn.classList.add('was-disabled');
}

const resetPages = () => {
  const enabledBtns = myPayDemo.querySelectorAll('.was-disabled');
  removeSelectedSelect();
  disableBtns(enabledBtns);
  disableBtns(myPayDemoInputSubmit);
  myPayDemoInput.value = '';
  myPayDemoInput.style.width = '';
  myPayDemoPointer.style.display = 'block';
}

const disableBtns = (btns) => {
  btns.forEach(btn => {
    btn.setAttribute('disabled', true);
  });
}

const removeSelectedSelect = () => {
  const selected = myPayDemo.querySelector('.mypay-demo__demo-select--selected');
  selected?.classList.remove(myPayDemoSelectedClass);
}

const enableTransferBtn = () => {
  if (myPayDemoInput.value >= 20 && myPayDemoInput.value <= 500) {
    myPayDemoInputSubmit.forEach(btn => {
      btn.removeAttribute('disabled');
      btn.classList.add('was-disabled');
    });
  } else {
    disableBtns(myPayDemoInputSubmit);
  }

  // grow input as typed
  let length = myPayDemoInput.value.length;
  length = length || 1;
  myPayDemoInput.style.width = length + 'ch';
}

if (myPayDemoTrigger) {
  myPayDemoTrigger.addEventListener('click', openDemo);
}

if (myPayDemoInputSubmit) {
  myPayDemoInputSubmit.forEach(btn => {
    btn.addEventListener('click', storeInputVal);
  });
}

if (myPayDemoReplay) {
  myPayDemoReplay.addEventListener('click', function() {
    closeTooltip();
    setActivePage(1);
    resetPages();
  });
}

if (myPayDemoNextBtns) {
  myPayDemoNextBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      setActivePage();
    });
  });
}

if (myPayDemoSelect) {
  myPayDemoSelect.forEach(select => {
    select.addEventListener('click', (e) => {
      enableNextBtn(e);
      myPayDemoPointer.style.display = 'none';
    });
  });
}

if (myPayDemoInput) {
  myPayDemoInput.addEventListener('input', enableTransferBtn);
}

if (myPayDemoInputForm) {
  myPayDemoInputForm.addEventListener('submit', function(e) {
    e.preventDefault();
  });
}

if (myPayDemoDisclaimer) {
  const myPayDemoDisclaimerBtn = myPayDemoDisclaimer.querySelector('.mypay-demo__demo-modal-btn');
  myPayDemoDisclaimerBtn.addEventListener('click', function() {
    myPayDemoDisclaimer.style.display = 'none';
    openTooltip();
  });
}

viewport.addEventListener('resize', viewportHandler);
